export const RESOURCE_ID_URL_PARAM = 'resourceId';
export const COMPANY_ID_URL_PARAM = 'companyId';
export const ORDER_ID_URL_PARAM = 'orderId';
export const WORKSHIFT_ID_URL_PARAM = 'workshiftId';
export const UNASSIGNED_PAGE_NUMBER_PARAM = 'unassigned_page';
export const CHOSEN_DATE = 'chosen_date';
export const ONLY_CURRENT_WORKSHIFT = 'only_current_workshift';
